import React from "react";
import "../styling/Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          {/* <div className="footer-logo">P</div> */}
          <p className="footer-description">
            The exclusive community platform for Pantheon VC, connecting
            visionary founders, investors, and industry leaders.
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h4>Platform</h4>
            <a href="/search">Find Founders</a>
            <a href="/form">Join Network</a>
            <a href="/resource">Resources</a>
          </div>

          <div className="footer-column">
            <h4>Network</h4>
            <a
              href="https://pantheon.nyc"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pantheon VC
            </a>
            <a
              href="https://pantheon.nyc/portfolio"
              target="_blank"
              rel="noopener noreferrer"
            >
              Portfolio
            </a>
            <a
              href="https://pantheon.nyc/team"
              target="_blank"
              rel="noopener noreferrer"
            >
              Team
            </a>
          </div>

          <div className="footer-column">
            <h4>Connect</h4>
            <a href="mailto:hello@pantheon.nyc">hello@pantheon.nyc</a>
            <a
              href="https://twitter.com/pantheonvc"
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter
            </a>
            <a
              href="https://www.linkedin.com/company/pantheonvc"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {currentYear} Pantheon Bookface. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
